import { render, staticRenderFns } from "./Slick1.vue?vue&type=template&id=47f06444&scoped=true&"
import script from "./Slick1.vue?vue&type=script&lang=js&"
export * from "./Slick1.vue?vue&type=script&lang=js&"
import style0 from "./Slick1.vue?vue&type=style&index=0&id=47f06444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f06444",
  null
  
)

export default component.exports